import React from 'react';

import Alert from 'components/shared/Alert';

const alertContentMap = {
  restore: {
    message: 'Are you sure you want to replace the current Project? Unsaved changes will be lost.',
    title: 'Replace Project',
    labelledBy: 'restore-project-alert-modal',
  },
  delete: {
    message: 'Are you sure you want to delete this project? This cannot be undone.',
    title: 'Delete Project',
    labelledBy: 'remove-project-alert-modal',
  },
};

type ProjectActionAlertProps = {
  alertType: 'restore' | 'delete';
  lastFocusedElementId: string;
  onContinue: () => void;
  onCancel: () => void;
  onClose: () => void;
};

function ProjectActionAlert(props: ProjectActionAlertProps) {
  const { alertType, lastFocusedElementId, onContinue, onCancel, onClose } = props;

  return (
    <Alert
      title={alertContentMap[alertType].title}
      labelledBy={alertContentMap[alertType].labelledBy}
      lastFocusedElementId={lastFocusedElementId}
      onClose={onClose}
      message={alertContentMap[alertType].message}
      onContinue={onContinue}
      onCancel={onCancel}
    />
  );
}

export default ProjectActionAlert;
